export default __webpack_public_path__ + "static/media/Monika Bulaj.95ff65f5.jpg";